(function () {
  Motion.file('inspector/section.js', function (require) {
    Motion.staticStyles('Inspector.Section', {
      '$': '#_motiondevtools .ViewInspector-Section',
      '$body': '#_motiondevtools body.Inspector-Section, #_motiondevtools .Inspector-Section.body, #_motiondevtools .ViewInspector-Section.body',
      '$inactive': '#_motiondevtools inactive.Inspector-Section, #_motiondevtools .Inspector-Section.inactive, #_motiondevtools .ViewInspector-Section.inactive'
    }, {
      '$': {
        padding: [0, 0, 5]
      },
      '$body': {
        padding: [0, 12]
      },
      '$inactive': {
        display: 'none'
      }
    });
    Motion.view('Inspector.Section', function (view, on, $) {
      var open = true;view.render(function () {
        return view.el(
          ['Inspector.Title', 1],
          { onToggle: function (val) {
              view.set('open', open = val);
              view.updateSoft();
            } },
          view.props.title
        );
      });view.render(function () {
        return view.el(
          ['body', 1],
          null,
          view.props.children
        );
      });
    });
  })
})();
//# sourceMappingURL=section.js.map
